import { getAgentApi } from '@/gql';
import { Chat } from '@/gql/agent/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseAgentChatsResult {
    chats: Chat[];
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Chat[]>;
}

export const useAgentChats = (
    agentUid: string,
    limit: number = 10,
): UseAgentChatsResult => {
    const [chats, setChats] = useState<Chat[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getChats = async () => {
        if (!agentUid || !userId) {
            setChats([]);
            return [];
        }
        try {
            setLoading(true);
            setError(null);
            const api = getAgentApi();
            const response = await api.chats({
                agentUid: agentUid,
                limit,
            });
            if (response?.chats !== undefined) {
                const reversedChats = response.chats.reverse();
                setChats(reversedChats);
                return reversedChats;
            } else {
                setChats([]);
                return [];
            }
        } catch (err) {
            console.error('Failed to fetch chats:', err);
            setError(
                err instanceof Error ? err : new Error('Failed to fetch chats'),
            );
            setChats([]);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChats();
    }, [agentUid, userId]);

    return {
        chats,
        loading,
        error,
        refetch: getChats,
    };
};
